export default __webpack_public_path__ + "assets/2415262c80f4905b7f7bde93ba5bea36.mp4";